import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {SearchMatchBox} from "./boxes/search-match.box";
import {removeSpecialCharacters} from "../../../../../utils/string-helpers";

export interface SearchListItemComponentProps {
  gameName : string;
}

@observer
export class HighlightSearchListItemComponent extends OrbitComponent<SearchListItemComponentProps> {
  render() {
    let searchText = removeSpecialCharacters(this.services.gameSearch.currentSearchText).toLowerCase();
    const gameName = this.props.gameName
    if(!searchText) {
      return gameName;
    }

    let index = removeSpecialCharacters(gameName).toLowerCase().indexOf(searchText);
    if(index < 0) {
      return gameName ;
    }

    const beforeHighlightText = gameName.substring(0, index);
    let highlightText = gameName.substring(index, index + searchText.length);
    // Found how many special characters we have in this string
    const numberOfSpecialCharacters = highlightText.length - removeSpecialCharacters(highlightText).length;
    highlightText = gameName.substring(index, index + searchText.length + numberOfSpecialCharacters);

    const afterHighlightText = gameName.substring(index + searchText.length + numberOfSpecialCharacters);

    return (
      <>
        {beforeHighlightText}<SearchMatchBox className={'cy-search-match'}>{highlightText}</SearchMatchBox>{afterHighlightText}
      </>
    )
  }
}
